import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "clearButton"]
  static values = { debounce: Number }

  connect() {
    this.debounceTimer = null
    this.toggleClearButton()
  }

  disconnect() {
    this.clearDebounceTimer()
  }

  debouncedSubmit() {
    this.toggleClearButton()
    this.clearDebounceTimer()

    this.debounceTimer = setTimeout(() => {
      this.submitForm()
    }, this.hasDebounceValue ? this.debounceValue : 300)
  }

  submitNow() {
    this.toggleClearButton()
    this.clearDebounceTimer()
    this.submitForm()
  }

  clearSearch(event) {
    event.preventDefault()

    if (this.hasSearchInputTarget) {
      this.searchInputTarget.value = ""
    }

    this.toggleClearButton()
    this.clearDebounceTimer()
    this.submitForm()
  }

  submitForm() {
    const form = this.element.tagName === "FORM" ? this.element : this.element.closest("form")
    if (!form) return

    this.updateUrl(form)

    if (typeof form.requestSubmit === "function") {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }

  toggleClearButton() {
    if (!this.hasClearButtonTarget) return

    const hasQuery = this.hasSearchInputTarget && this.searchInputTarget.value.trim().length > 0
    this.clearButtonTarget.classList.toggle("d-none", !hasQuery)
  }

  clearDebounceTimer() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = null
    }
  }

  updateUrl(form) {
    const url = new URL(form.action || window.location.pathname, window.location.origin)
    const formData = new FormData(form)

    formData.forEach((value, key) => {
      const normalizedValue = String(value).trim()

      if (normalizedValue.length > 0) {
        url.searchParams.set(key, normalizedValue)
      } else {
        url.searchParams.delete(key)
      }
    })

    url.searchParams.delete("page")

    const nextUrl = url.searchParams.toString().length > 0 ? `${url.pathname}?${url.searchParams.toString()}` : url.pathname
    window.history.replaceState({}, "", nextUrl)
  }
}